import $api from "@/frontend/shared/api/axios";

export async function postInviteUser({ email }: { email: string }) {
  await $api.post("/organizations/invite", { email: email });
}
